import React from 'react';
import { ClientMultipliersConfig, ClientSurchargeConfig } from '../../client_configuration';
import type { ClientFormData } from '../utilities/formDataUtils';
import type { ValidationError } from '@/utils/validation/types';
import type { UserConfigurationState } from '@/types/userConfiguration';

interface MultipliersStepProps {
  formData: ClientFormData;
  handleChange: (field: keyof ClientFormData, value: ClientFormData[keyof ClientFormData]) => void;
  handleSwitchChange: (field: keyof ClientFormData, checked: boolean) => void;
  onFieldBlur: (field: keyof ClientFormData) => void;
  isLoading: boolean;
  errors: ValidationError[];
  touchedFields: Set<string>;
  granularCustomizedFields: Record<string, boolean>;
  granularCustomized: {
    multipliers: boolean;
    shortTurn: boolean;
    holiday: boolean;
    mealBreak: boolean;
    overnight: boolean;
  };
  onRevertSection: (section: 'multipliers' | 'shortTurn' | 'holiday' | 'mealBreak' | 'overnight') => void;
  userDefaults?: UserConfigurationState;
  onMultipliersValidityChange: (isValid: boolean) => void;
}

const MultipliersStepComponent: React.FC<MultipliersStepProps> = ({
  formData,
  handleChange,
  handleSwitchChange,
  onFieldBlur,
  isLoading,
  errors,
  touchedFields,
  granularCustomizedFields,
  granularCustomized,
  onRevertSection,
  userDefaults,
  onMultipliersValidityChange,
}) => {
  return (
    <div className="space-y-6">
      <ClientMultipliersConfig
        formData={formData}
        handleChange={handleChange}
        handleSwitchChange={handleSwitchChange}
        onFieldBlur={onFieldBlur}
        isLoading={isLoading}
        errors={errors}
        touchedFields={touchedFields}
        isCustomized={granularCustomized.multipliers}
        onRevert={() => onRevertSection('multipliers')}
        userDefaultMultipliers={userDefaults?.rateMultipliers}
        onValidityChange={onMultipliersValidityChange}
      />
      <ClientSurchargeConfig
        formData={formData}
        handleChange={handleChange}
        handleSwitchChange={handleSwitchChange}
        onFieldBlur={onFieldBlur}
        isLoading={isLoading}
        errors={errors}
        touchedFields={touchedFields}
        granularCustomized={{
          holiday: granularCustomized.holiday,
          mealBreak: granularCustomized.mealBreak,
          shortTurn: granularCustomized.shortTurn,
          overnight: granularCustomized.overnight,
        }}
        onRevertSection={onRevertSection}
        granularCustomizedFields={granularCustomizedFields}
      />
    </div>
  );
};

export const MultipliersStep = React.memo(MultipliersStepComponent);
